import { type FC } from "react";

import { cn } from "@/shared/lib/utils";

import type { FormField } from "@/shared/types/estateEssentials";

import { FieldLabel } from "./FieldGrid";
import { FormFieldInput } from "./FormFieldInput";

export function fieldByKey(fields: FormField[], key: string): FormField {
  return fields.find((f) => f.key === key)!;
}

interface FieldCellProps {
  field: FormField;
  value: string;
  error: boolean;
  onChange: (key: string, value: string) => void;
  className?: string;
}

export const FieldCell: FC<FieldCellProps> = ({ field, value, error, onChange, className }) => (
  <div className={cn("flex flex-col gap-1", className)}>
    <FieldLabel field={field} />
    <FormFieldInput
      field={field}
      value={value}
      onFieldChange={onChange}
      fieldKey={field.key}
      attention={error}
    />
  </div>
);
